import * as React from 'react';
// import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';

export default function Tags({ value, filterKey, updateState, inputName, options, required = false }) {
    const handleChange = (event, newValue) => {
        // console.log(newValue)
        // const newValue = event.target.value;
        updateState({ [filterKey]: newValue });
    };

  return (
    <Stack spacing={3}>
      <Autocomplete
        fullWidth={true}
        multiple
        size="small"
        id="tags-outlined"
        options={options.map(i=>i.label)}
        value={value}
        onChange={handleChange}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            label={inputName}
            required={required}
          />
        )}
      />

    </Stack>
  );
}
